import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

class SumSex extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._onGetData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onGetData = async () => {
    const result = await this._onGetDataApi();
    const intReturn = result.data[0].intReturn;
    const maxSum = result.data[0].maxSum;
    const sumList = result.data[0].listData;

    ////console.log(maxSum, sumList[0].age30)

    if (intReturn === 0) {
      const sum =
        sumList[0].age10 +
        sumList[0].age20 +
        sumList[0].age30 +
        sumList[0].age40 +
        sumList[0].age50;
      if (this._isMounted) {
        this.setState({
          sumList: sumList,
          maxSum,
          age10: (sumList[0].age10 / sum) * 100,
          age20: (sumList[0].age20 / sum) * 100,
          age30: (sumList[0].age30 / sum) * 100,
          age40: (sumList[0].age40 / sum) * 100,
          age50: (sumList[0].age50 / sum) * 100,
        });
      }
    }
  };
  _onGetDataApi = () => {
    const { apiUrl } = this.props;
    const { contentSerial } = this.props.childProps;

    //console.log(apiUrl + '/ageViewSum?contentSerial=' + contentSerial)
    return axios(apiUrl + "/ageViewSum?contentSerial=" + contentSerial)
      .then((response) => response)
      .catch((error) => {
        //console.log('통계오류')
      });
  };

  render() {
    const { sumList } = this.state;
    const { age10, age20, age30, age40, age50, maxSum } = this.state;

    return (
      <Fragment>
        {sumList ? (
          <dd>
            <div
              className={maxSum === sumList[0].age10 ? "on" : null}
              style={{ height: age10.toFixed(0) + "%" }}
            >
              <em>{age10.toFixed(0)}%</em>
              <p>10대</p>
            </div>
            <div
              className={maxSum === sumList[0].age20 ? "on" : null}
              style={{ height: age20.toFixed(0) + "%" }}
            >
              <em>{age20.toFixed(0)}%</em>
              <p>20대</p>
            </div>
            <div
              className={maxSum === sumList[0].age30 ? "on" : null}
              style={{ height: age30.toFixed(0) + "%" }}
            >
              <em>{age30.toFixed(0)}%</em>
              <p>30대</p>
            </div>
            <div
              className={maxSum === sumList[0].age40 ? "on" : null}
              style={{ height: age40.toFixed(0) + "%" }}
            >
              <em>{age40.toFixed(0)}%</em>
              <p>40대</p>
            </div>
            <div
              className={maxSum === sumList[0].age50 ? "on" : null}
              style={{ height: age50.toFixed(0) + "%" }}
            >
              <em>{age50.toFixed(0)}%</em>
              <p>50대↑</p>
            </div>
          </dd>
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(SumSex));
